import { GroupBuyStatus } from '@/components/types/group-buy';

export const STATUS_STYLES: Record<GroupBuyStatus, string> = {
  active: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700',
  expired: 'bg-gray-100 text-gray-700',
  processing_payments: 'bg-yellow-100 text-yellow-700',
};

export const STATUS_TEXT: Record<GroupBuyStatus, string> = {
  active: 'Active',
  completed: 'Completed',
  cancelled: 'Cancelled',
  expired: 'Expired',
  processing_payments: 'Processing Payments',
};
